import { useEffect, useState } from "react";
import type { LucideIcon } from "lucide-react";

type IconMap = Record<string, LucideIcon>;

// The full lucide icon map (~620KB) is only needed where icon names are user
// data (Advanced Card display, icon picker). It must come from the
// lucide-react-full package alias, NOT "lucide-react": a namespace import of
// the same module the eager graph uses statically retains every icon and
// drags the whole library into the boot bundle.
let cache: IconMap | null = null;
let pending: Promise<IconMap> | null = null;

function loadLucideIcons() {
  pending ??= import("lucide-react-full").then(m => {
    cache = m.icons as unknown as IconMap;
    return cache;
  });
  return pending;
}

export function useLucideIcons(): IconMap | null {
  const [icons, setIcons] = useState(cache);

  useEffect(() => {
    if (!icons) {
      loadLucideIcons().then(setIcons);
    }
  }, [icons]);

  return icons;
}
